import React from "react";
import "../styles/Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faTwitter, faTelegram, faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">

        {/* Left Section */}
        <div className="footer-left">
          <h3>ShopSphere</h3>
          <p>© 2025 ShopSphere. All rights reserved.</p>
          <p>Your one-stop online store for Men, Women, Kids, Electronics, Beauty, Jewellery, and more ...</p>
        </div>

        {/* Center Section */}
        <div className="footer-center">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/home">Home</a></li>
            <li><a href="/products">Products</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/cart">Cart</a></li>
            <li><a href="/login">Login / Signup</a></li>
          </ul>
        </div>

        {/* Right Section */}
        <div className="footer-right">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://github.com/VALLISRIMANI/ShopSphere" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><FontAwesomeIcon icon={faGithub} /></a>
            <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FontAwesomeIcon icon={faFacebookF} /></a>
            <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FontAwesomeIcon icon={faInstagram} /></a>
            <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FontAwesomeIcon icon={faTwitter} /></a>
            <a href="https://telegram.org/" target="_blank" rel="noopener noreferrer" aria-label="Telegram"><FontAwesomeIcon icon={faTelegram} /></a>
            <a href="https://linkedin.com/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FontAwesomeIcon icon={faLinkedin} /></a>
          </div>
          <div className="contact-info">
            <p>Email: <a href="mailto:support@shopsphere.com">support@shopsphere.com</a></p>
            <p>Phone: <a href="tel:+919876543210">+91 98765 43210</a></p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;